import { useBreakPoints, useCrowdFundingTranslations } from 'core/Hooks';
import { ButtonMantine, Center, Stack, Title } from 'ui';

import { useShowCausesDonations } from '../../../hooks/queries/Core/causes';
import { RecentDonationCard } from '../RecentDonationCard/RecentDonationCard';

type RecentDonationsProps = {
  causeId: string;
};

const RecentDonations = ({ causeId }: RecentDonationsProps) => {
  const { data, fetchNextPage, isLoading, hasNextPage } = useShowCausesDonations(causeId);
  const { isDesktop } = useBreakPoints();
  const { t } = useCrowdFundingTranslations(causeId);

  if (isLoading) {
    return <div>Loading ...</div>;
  }

  if (data?.pages.some((page) => page.donations.length <= 0)) return null;

  return (
    <>
      {data?.pages && (
        <Stack>
          <Title order={2} mb={4} c="gray.8">{`Recent ${t('Donations')}`}</Title>

          {data?.pages.map((page) =>
            page.donations.map((donor) => <RecentDonationCard key={donor.uuid} donorData={donor} />)
          )}

          {isDesktop && hasNextPage && (
            <Center mt={8}>
              <ButtonMantine size="sm" w={122} onClick={() => void fetchNextPage()}>
                View More
              </ButtonMantine>
            </Center>
          )}
        </Stack>
      )}
    </>
  );
};

export { RecentDonations };
